import { Indicators, Lobby, Location, Registrations, Attendance, InboundTruck, Antenna } from "assets/icons/index";
import { Roles } from "utils/functions";

const lobbyUrl = "/private/lobby";
const attendanceUrl = "/private/attendance";
const locationUrl = "/private/location";
const userUrl = "/private/user";
const documentUrl = "/private/document";
const inboundAndOutboundReportUrl = "/private/report/inbound-outbound";
const dashboardUrl = "/private/readers-tags/dashboard";
const tagsUrl = "/private/readers-tags/tags";
const readersUrl = "/private/readers-tags/readers";
const movimentsUrl = "/private/report/movements";
const processUrl = "/private/process";
const vehicleDashboardUrl = "/private/vehicle-dashboard";
const locationRegistration = "location_registration";
const userEditPath = "/private/user/user-edit";
const unitFormPath = "/private/location/form";
const unitFormEditPath = "/private/location/form/[id]";
const lobby = "lobby";
const attendance = "attendance";
const units = "units";
const users = "users";
const process = "processes_list";
const documents = "documents";
const configuration = "configuration";
const userEdit = "user_edit";
const unitEdition = "unit_edition";
const inboundAndOutboundReports = "inbound_and_outbound";
const reports = "report";
const movements = "movements";
const vehicleDashboard = "vehicle_dashboard";
const readersAndTags = "readers_and_tags";
const dashboard = "dashboard";
const readers = "readers";
const tags = "tags";

const roleWithFullAccess = [
  `${Roles.ADMIN}`,
  `${Roles.CONCIERGE}`,
  `${Roles.CONTROL}`,
  `${Roles.VISIT}`,
  `${Roles.CONCIERGE_LEADER}`,
  `${Roles.ATTENDANCE}`,
  `${Roles.CONCIERGE_ATTENDANCE}`,
];

export const menuList = [
  {
    id: "12",
    label: attendance,
    title: attendance,
    path: attendanceUrl,
    hideItem: false,
    icon: Attendance,
    role: [`${Roles.ADMIN}`, `${Roles.CONTROL}`, `${Roles.ATTENDANCE}`, `${Roles.CONCIERGE_ATTENDANCE}`, `${Roles.VISIT}`],
  },
  {
    id: "1",
    label: lobby,
    title: lobby,
    path: lobbyUrl,
    hideItem: false,
    icon: Lobby,
    role: roleWithFullAccess,
  },
  {
    id: "2",
    label: reports,
    title: reports,
    path: "",
    hideItem: false,
    icon: Indicators,
    role: roleWithFullAccess,
    Items: [
      {
        id: "13",
        label: inboundAndOutboundReports,
        title: inboundAndOutboundReports,
        path: inboundAndOutboundReportUrl,
        hideItem: false,
        role: roleWithFullAccess,
      },
      {
        id: "14",
        label: movements,
        title: movements,
        path: movimentsUrl,
        hideItem: false,
        role: roleWithFullAccess,
      },
    ],
  },
  {
    id: "16",
    label: readersAndTags,
    title: readersAndTags,
    path: "",
    hideItem: false,
    icon: Antenna,
    role: roleWithFullAccess,
    Items: [
      {
        id: "17",
        label: dashboard,
        title: dashboard,
        path: dashboardUrl,
        hideItem: false,
        role: roleWithFullAccess,
      },
      {
        id: "18",
        label: readers,
        title: readers,
        path: readersUrl,
        hideItem: false,
        role: [`${Roles.ADMIN}`],
      },
      {
        id: "19",
        label: tags,
        title: tags,
        path: tagsUrl,
        hideItem: false,
        role: [`${Roles.ADMIN}`, `${Roles.ATTENDANCE}`, `${Roles.CONCIERGE_ATTENDANCE}`],
      },
    ],
  },
  {
    id: "15",
    label: vehicleDashboard,
    title: vehicleDashboard,
    path: vehicleDashboardUrl,
    hideItem: false,
    icon: InboundTruck,
    role: [`${Roles.ADMIN}`, `${Roles.CONTROL}`, `${Roles.ATTENDANCE}`, `${Roles.VISIT}`, `${Roles.CONCIERGE_ATTENDANCE}`],
  },
  {
    id: "3",
    label: configuration,
    title: configuration,
    path: "",
    hideItem: false,
    icon: Registrations,
    role: [`${Roles.ADMIN}`, `${Roles.CONCIERGE_LEADER}`],
    Items: [
      {
        id: "4",
        label: units,
        title: units,
        path: locationUrl,
        hideItem: false,
        icon: Location,
        role: [`${Roles.ADMIN}`],
      },
      {
        id: "5",
        label: users,
        title: users,
        path: userUrl,
        hideItem: false,
        icon: Registrations,
        role: [`${Roles.ADMIN}`, `${Roles.CONCIERGE_LEADER}`],
      },
      {
        id: "6",
        label: userEdit,
        title: userEdit,
        path: userEditPath,
        hideItem: true,
        icon: Registrations,
        role: [`${Roles.ADMIN}`, `${Roles.CONCIERGE_LEADER}`],
      },
      {
        id: "7",
        label: locationRegistration,
        title: locationRegistration,
        path: unitFormPath,
        hideItem: true,
        icon: Location,
        role: [`${Roles.ADMIN}`],
      },
      {
        id: "8",
        label: unitEdition,
        title: unitEdition,
        path: unitFormEditPath,
        hideItem: true,
        icon: Location,
        role: [`${Roles.ADMIN}`],
      },
      {
        id: "9",
        label: documents,
        title: documents,
        path: documentUrl,
        hideItem: false,
        icon: Registrations,
        role: [`${Roles.ADMIN}`],
      },
      {
        id: "10",
        label: process,
        title: process,
        path: processUrl,
        hideItem: false,
        icon: Registrations,
        role: [`${Roles.ADMIN}`],
      },
    ],
  },
];
